import { ChatProvider } from "@/contexts/chat/provider";
import { AuthProvider } from "contexts/auth";
import { ReportProvider } from "contexts/report";
// eslint-disable-next-line import/order
import { TaskProvider } from "contexts/task";
import { Provider } from "jotai";
import { DevTools } from "jotai-devtools";
import { AppProps } from "next/app";
import Router from "next/router";
import NProgress from "nprogress";
import React, { useEffect, useState } from "react";

import "@/styles/global.scss";
import "@/styles/destyle.scss";
import "@/styles/global.css";
import "@/styles/components/shared/animation.css";
import "@/styles/slick_overwrite.scss";

import "@fontsource/noto-sans-jp/400.css";
import "@fontsource/noto-sans-jp/500.css";
import "@fontsource/noto-sans-jp/700.css";
import "@fontsource/noto-sans-jp/900.css";
import "@fontsource/roboto/500.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-calendar/dist/Calendar.css";
import "react-image-crop/dist/ReactCrop.css";
import "react-datepicker/dist/react-datepicker.css";
import "nprogress/nprogress.css";
import "animate.css";
import "tailwindcss/tailwind.css";
import "jotai-devtools/styles.css";

import ClarityTag from "@/components/shared/clarityTag";
import ReloadAlert from "@/components/shared/reloadAlert";
import GoogleTagManager from "components/shared/googleTagManager";

const MyApp = ({ Component, pageProps }: AppProps): JSX.Element => {
  const [isDevTools, setIsDevTools] = useState(false);

  useEffect(() => {
    //nprogress
    Router.events.on("routeChangeStart", () => NProgress.start());
    Router.events.on("routeChangeComplete", () => NProgress.done());
    Router.events.on("routeChangeError", () => NProgress.done());
    const isProduction = process.env.NODE_ENV === "production";
    setIsDevTools(!isProduction);
  }, []);

  return (
    <Provider>
      {isDevTools && <DevTools />}
      <AuthProvider>
        <ChatProvider>
          <ReportProvider>
            <TaskProvider>
              <GoogleTagManager googleTagManagerId={process.env.GTM} />
              <ClarityTag />
              <React.StrictMode>
                <Component {...pageProps} />
              </React.StrictMode>
              <ReloadAlert />
            </TaskProvider>
          </ReportProvider>
        </ChatProvider>
      </AuthProvider>
    </Provider>
  );
};

export default MyApp;
